export default function initOrderTabs() {
    const orderTabs = document.querySelectorAll(".tab__control");
    const contentPanel = document.querySelectorAll(".tab-panel");

    for (let i = 0; i < orderTabs.length; i++) {
        orderTabs[i].onclick = myTabClicks;
    }

    function myTabClicks(tabClick) {
        for (let i = 0; i < orderTabs.length; i++) {
            orderTabs[i].classList.remove("active");
        }
        let clickedTab = tabClick.currentTarget;
        clickedTab.classList.add("active");
        tabClick.preventDefault();

        for (let i = 0; i < contentPanel.length; i++) {
            contentPanel[i].classList.remove("active");
        }

        let anchorReference = tabClick.target;
        let activePanelId = anchorReference.getAttribute("data-name");
        let activePanel = document.querySelector(activePanelId);
        activePanel.classList.add("active");
    }

    for (let i = 0; i < orderTabs.length; i++) {
        orderTabs[i].addEventListener("click", myTabClicks);
    }

    const buttonSchouwing = document.querySelectorAll(".js-schouwing");
    for (let i = 0; i < buttonSchouwing.length; i++) {
        buttonSchouwing[i].addEventListener("click", schouwingClick);
    }

    function schouwingClick(schouwingButton) {
        schouwingButton.preventDefault();
        for (let i = 0; i < orderTabs.length; i++) {
            orderTabs[i].classList.remove("active");
            const orderTabSchouwing = document.querySelector('[data-name="#schouwing"]')
            orderTabSchouwing.classList.add("active");
        }
        for (let i = 0; i < contentPanel.length; i++) {
            contentPanel[i].classList.remove("active");
        }
        const tabSchouwingContent = document.querySelector('.tab-schouwing');
        tabSchouwingContent.classList.add("active");

    }

    // check for schouwing in URL and show schouwingstab

    if (window.location.hash) {
        if (window.location.hash === '#schouwing') {
            for (let i = 0; i < orderTabs.length; i++) {
                orderTabs[i].classList.remove("active");
                const orderTabSchouwing = document.querySelector('[data-name="' + window.location.hash + '"]')
                orderTabSchouwing.classList.add("active");
            }
            for (let i = 0; i < contentPanel.length; i++) {
                contentPanel[i].classList.remove("active");
            }
            const tabSchouwingContent = document.querySelector('.tab-schouwing');
            tabSchouwingContent.classList.add("active");
        }
    }
}
